import Header from '@/components/Header';
import Landing from '@/pages/Landing';

// The static marketing page tree, shared by the client (hydration) and the
// build-time prerender. Kept deliberately small — no LiveKit / tldraw / auth
// probe — so it renders to static HTML cleanly via react-dom/server.
function LandingApp() {
  return (
    <div id="app">
      <Header withBorder hideAuth />
      <Landing />
    </div>
  );
}

export default LandingApp;
